import React, {Component} from 'react';
import {SortableTableHeader} from "../../components/table/sortable-table-header";



export default class SiteTableHeader extends Component
{
  //SiteTableHeader
  static Layout = [
    { column: "companySiteName", width: 3, name: "Site Name" },
    { column: "town" },
    { column: "postcode" },
    { column: "siteStatus", width: 2, name:"Status"},
    { column: "locationId", width: 2, name:"Reference"},
    { column: "empty", width: 2 }
  ];

  static LayoutFund = [
    { column: "companySiteName", width: 3, name: "Site Name" },
    { column: "town" },
    { column: "postcode" },
    { column: "client" },
    { column: "fund" },
    { column: "siteStatus", width: 2, name:"Status"},
    { column: "empty", width: 2 }
  ];

  render() {
    return (
      
    <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={SiteTableHeader.Layout}/>)

  }
}